module.exports = __webpack_public_path__ + "./assets/406b928fc8f36d01edcce904d940491a.woff";